import { render, staticRenderFns } from "./DashboardPromotionalPanel.vue?vue&type=template&id=d45aad4e&"
import script from "./DashboardPromotionalPanel.vue?vue&type=script&lang=js&"
export * from "./DashboardPromotionalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports